import { useEffect } from 'react';

import { AppSideBar } from '@/components/AppSideBar';

import { DisplayToast } from '@/helpers';

import { SidebarMenuProps, ToastMessagesType } from '@/types';

import { Header } from './Header';
import { ThemedToaster } from './ThemedToaster';

export const AppLayout = (props: SidebarMenuProps) => {
  const { children, ...restProps } = props;

  const { flash } = (JSON.parse(
    document.getElementById('flash-root')!.getAttribute('data') as string,
  ) || []) as ToastMessagesType;

  useEffect(() => {
    if (!flash || flash.length === 0) return;
    flash.forEach(({ text, type }) => {
      DisplayToast[type](text);
    });
  }, [flash]);

  return (
    <>
      <Header {...restProps} />
      <div className="flex flex-1">
        <AppSideBar {...restProps} />
        <div className="flex w-full min-w-0 shrink flex-col overflow-x-clip">
          <main
            data-slot="app-main"
            className="bg-background size-full p-2 md:px-6 md:py-2"
          >
            {children}
          </main>
        </div>
      </div>
      <ThemedToaster />
    </>
  );
};
